export default {
    init: function() {
        $('.js-validate-form').validate({});

        $('.js-form').validate({
            submitHandler: function (form) {

                var $form = $(form);

                $('.js-form-btn', $form).hide();
                $('.js-form-loader', $form).show();
                $('.js-form-success', $form).hide();
                $('.js-form-error', $form).hide();

                $.post($form.attr('action'), $form.serialize(), function (response) {

                    if (response.error) {
                        $('.js-form-error', $form).html(response.error).show();
                    } else {
                        $('.js-form-success', $form).show();
                        // gtag('event', 'web_form_send_click', {
                        //     eventCategory: 'web_forms_clicks',
                        //     eventAction: 'form_submit_click',
                        //     eventLabel: 'enquiry web form'
                        // })
                    }

                    $('.js-form-loader', $form).hide();
                    $('.js-form-btn', $form).show();
                    // $('.js-form-content').hide();
                });


                return false;

            }
        });

        $('.js-show-form').click(function () {
            var button = $(this);

            button.parent().find('.js-form').show();
            button.hide();
            return false;
        });
    }
};
